import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollAppToTop } from '../../utils/scrollAppToTop';

/** Reset scroll when the route path changes (navbar switches between pages). */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollAppToTop();
  }, [pathname]);

  return null;
};

export default ScrollToTop;
